//@flow
import {
    KRATOS_EC_DOC_SUBMIT_SUCCESS,
    KRATOS_EC_DOC_SUBMIT_ERROR,
    KRATOS_EC_DOC_SUBMITTED_COMPLETED,
    EDIT_KRATOS_EC_VERIFY_FORM_DATA_SUCCESS,
    EDIT_KRATOS_EC_VERIFY_FORM_DATA_ERROR
} from './actionTypes';
import reduce from '../reduce';
import type { ReducerState,ReducerAction } from './flowTypes'

const initialState:ReducerState = {
    error: '',
    docSubmitted: false,
    anyChanges: false,
    renewIndicators: [
        { code: 'Empty', desc: 'Empty'},
        { code: 'Filled', desc: 'Filled'}
    ],
    renewUnitIndicators: [
        { code: 'Empty', desc: 'Empty'},
        { code: 'Preprinted', desc: 'Preprinted'},
        { code: 'Handwritten', desc: 'Handwritten'},
        { code: 'Preprinted & Handwritten', desc: 'Preprinted & Handwritten'}
    ],
    yesOrNoIndicators: [
        { code: 'Yes', desc: 'Yes'},
        { code: 'No', desc: 'No'}
    ],
    exemptionCodes: [
        { code: 'T1', desc: 'T1'},
        { code: 'S5', desc: 'S5'},
        { code: 'T3', desc: 'T3'},
        { code: 'Empty', desc: 'Empty'}
    ],
    checkIndicators: [
        { code: 'Checked', desc: 'Checked'},
        { code: 'Not Checked', desc: 'Not Checked'}
    ],
    formData: {},
    reviewQuestions: []
}

const docSubmittedSuccess = (state:ReducerState) => {
    return {
        ...state,
        docSubmitted: true,
        error: '',
    }
}

const docSubmittedError = (state:ReducerState,action: ReducerAction) => {
    return {
        ...state,
        error: action.error
    }
}

const docSubmittedCompleted = (state:ReducerState) => {
    return {
        ...state,
        docSubmitted: false
    }
}

const editVerifyFormDataSuccess=(state:ReducerState,action:ReducerAction)=>{
    return {
        ...state,
        error: '',
        formData: action.formData,
        reviewQuestions: action.reviewQuestions
    }
}

const editVerifyFormDataError=(state:ReducerState,action:ReducerAction)=>{
    return {
        ...state,
        error: action.error
    }
}

export default reduce(initialState,{
    [KRATOS_EC_DOC_SUBMIT_SUCCESS]: docSubmittedSuccess,
    [KRATOS_EC_DOC_SUBMIT_ERROR]: docSubmittedError,
    [KRATOS_EC_DOC_SUBMITTED_COMPLETED]: docSubmittedCompleted,
    [EDIT_KRATOS_EC_VERIFY_FORM_DATA_ERROR]: editVerifyFormDataError,
    [EDIT_KRATOS_EC_VERIFY_FORM_DATA_SUCCESS]: editVerifyFormDataSuccess
});


// WEBPACK FOOTER //
// ./src/redux/kratosec/reducer.js